/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:08:57
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { mapGetters } from 'vuex';
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyAccountBanner',

  components: { SmallLoadingSpinner },

  computed: {
    ...mapGetters(['bannersList', 'pendingStoreActions']),
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyAccountBanner/component.js